<template>
  <div class="artwork-alert">
    <div
      :class="
        showNewGangSheetErrorMessage ? 'artwork-alert__new-container' : 'artwork-alert__container'
      "
    >
      <div v-if="!showNewGangSheetErrorMessage" class="artwork-alert__icon">
        <UseSvg icon="warning" class="artwork-alert__warning" />
      </div>
      <div class="artwork-alert__message">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import UseSvg from "components/jiffy/vue-cart/UseSvg.vue";
import { useDtfStore } from "./store";

const store = useDtfStore();
const showNewGangSheetErrorMessage = computed(() => store.showNewGangSheetErrorMessage);
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";

.artwork-alert {
  &__container {
    width: 100%;
    display: flex;
    background: $red-error-background-2;
    padding: 8px 14px;
    font-size: 14px;
    color: $red-light;
    align-items: center;
    border-radius: 4px;
  }

  &__new-container {
    width: 100%;
    display: flex;
    background: $white;
    padding: 8px 14px;
    font-size: 14px;
    align-items: center;
    border-radius: 10px;
    justify-content: space-between;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: 1px solid #e5e5e5;
  }

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
  }

  &__message {
    flex: 1;
  }

  &__warning {
    width: 21px;
    height: 21px;
  }
}
</style>
